export default {
  loadedRecipients: [],
  emailRecipients: [],
  phoneRecipients: [],
  manuallyTriggered: false,
};
